/** The card pill's text (2.M deliverable 9, pure). */
import type { RulesRecordV1 } from '@codex/contracts';
import { RARITY_LABELS } from '@codex/dnd5e/schema';

/** "1st", "2nd", "3rd", "4th" … "9th". */
export function ordinal(level: number): string {
  const suffix = level === 1 ? 'st' : level === 2 ? 'nd' : level === 3 ? 'rd' : 'th';
  return `${level}${suffix}`;
}

/** "Spell card · Cantrip", "Spell card · 3rd level", "Item card · Rare", "Item card"; none: "Add card". */
export function cardPillText(record: RulesRecordV1 | null): string {
  if (record === null) return 'Add card';
  if (record.kind === 'spell') {
    const level = record.data.level;
    return `Spell card · ${level === 0 ? 'Cantrip' : `${ordinal(level)} level`}`;
  }
  const rarity = record.data.rarity;
  return rarity === null ? 'Item card' : `Item card · ${RARITY_LABELS[rarity]}`;
}
